import { Component, OnInit, Input } from "@angular/core";
import { OperationHistoryService } from "@edp-services/operation-history.service";
import { PaymentResult } from "@edp-models/edp-payment.model";
import { EdpModalService } from "@edp-components/edp-modal";
import { FormGroup, Validators, FormControl } from "@angular/forms";
import { EdpToasterService, EdpToast } from "@edp-components/edp-toaster/edp-toaster.service";
import { EdpToastType } from "@edp-components/edp-toaster/edp-toast-type";
import { TranslateService } from "@ngx-translate/core";

enum PaymentLogStatus {
    OPENBANKING_CLOSE_TAB = "OPENBANKING_CLOSE_TAB",
    OPENBANKING_PAYMENT_FEEDBACK = "OPENBANKING_PAYMENT_FEEDBACK",
}

@Component({
    selector: "edp-payment-user-feedback-modal",
    templateUrl: "./edp-payment-user-feedback-modal.component.html",
    styleUrls: ["./edp-payment-user-feedback-modal.component.scss"]
})
export class EdpPaymentUserFeedbackModalComponent implements OnInit {
    @Input() data: PaymentResult;

    public otherFeedbackSelected = false;
    public arrayPaymentFeedback = [
        { name: "pt.edp.edponline.payment.modal.error.feedback.notSafe", value: "notSafe" },
        { name: "pt.edp.edponline.payment.modal.error.feedback.additionalCosts", value: "additionalCosts" },
        { name: "pt.edp.edponline.payment.modal.error.feedback.howItWorks", value: "howItWorks" },
        { name: "pt.edp.edponline.payment.modal.error.feedback.paymentError", value: "paymentError" },
        { name: "pt.edp.edponline.payment.modal.error.feedback.other", value: "other" }
    ];
    public feedbackForm = new FormGroup({
        otherFeedback: new FormControl("", [Validators.required, Validators.minLength(3), Validators.maxLength(70)])
    });
    private feedbackToasterOpenBanking: EdpToast;

    constructor(
        private operationHistoryService: OperationHistoryService,
        private edpModalService: EdpModalService,
        private toaster: EdpToasterService,
        private translate: TranslateService
    ) { }

    ngOnInit() {
        this.feedbackToasterOpenBanking = this.toaster.create(
            this.translate.instant("pt.edp.edponline.payment.modal.error.feedback.message"),
            EdpToastType.info
        );
    }

    public closeModal(): void {
        this.operationHistoryService.registerWithContract(this.data.contract.ContractId, PaymentLogStatus.OPENBANKING_CLOSE_TAB);
        this.edpModalService.close(false);
    }

    public feedbackChoice(feedback) {
        if (feedback.value === "other") {
            this.otherFeedbackSelected = true;
        } else {
            this.logOperation(PaymentLogStatus.OPENBANKING_PAYMENT_FEEDBACK, feedback.name);
        }
    }

    public feedbackSubmit() {
        this.logOperation(PaymentLogStatus.OPENBANKING_PAYMENT_FEEDBACK, this.feedbackForm.get("otherFeedback").value);
    }

    private logOperation(op: PaymentLogStatus, feedback?: string) {
        this.operationHistoryService.registerWithContract(this.data.contract.ContractId, op, feedback);
        if (!this.feedbackToasterOpenBanking.getVisibility()) {
            this.feedbackToasterOpenBanking.show();
        }
        this.edpModalService.close(false);
    }
}
